import { render, staticRenderFns } from "./AssessmentInstitution.vue?vue&type=template&id=2eb460c0"
import script from "./AssessmentInstitution.vue?vue&type=script&lang=js"
export * from "./AssessmentInstitution.vue?vue&type=script&lang=js"
import style0 from "./AssessmentInstitution.vue?vue&type=style&index=0&id=2eb460c0&prod&lang=css"
import style1 from "./AssessmentInstitution.vue?vue&type=style&index=1&id=2eb460c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports